/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

import '../stylesheets/application.scss';

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
import 'core-js/stable';

import 'src/sideNavToggle';
import emojiMart from 'src/emoji-mart';
import 'src/listGroupSelect';
import 'src/newCaseDetails';
import 'src/newNewCaseForm';
import {initTimeline} from "../src/actionOwnerTimeline";
import {initAssetVisualiser, initAssetContainerVisualiser} from "../src/asset-vis";
import { initClusterTrees } from 'src/cluster-tree';
import { initClusterServicesOverview } from "../src/clusterServicesOverview";
import {renderFaqSearch} from "../src/faqsearch";
import { initCalendar } from 'src/fullcalendar';
import {renderOmnisearch} from "../src/omnisearch";
import { initTours } from '../src/tours';
import { initCaseTriageForm } from '../src/triage';
import { initVdc2d } from "../src/vdc-2d";
import { initVdcAssetList } from "../src/vdc-asset-list";
import { initRecentActivityList } from '../src/recentActivity';
import { initWorkflowQuestionWizards } from '../src/workflowQuestions';
import { initCheckResultForm } from '../src/checkResultForm';

document.addEventListener('DOMContentLoaded', () => {
  renderOmnisearch();
  renderFaqSearch();
  initClusterTrees();
  initCalendar();
  initAssetVisualiser(document.getElementById('assetVisualiser'));
  initAssetContainerVisualiser(document.getElementById('assetContainerVisualiser'));
  initTimeline(document.getElementById('action-owner-timeline-container'));
  initClusterServicesOverview(document.getElementById('cluster-services-overview'));
  initVdcAssetList(document.getElementById('vdcAssetList'));
  initRecentActivityList(document.getElementById('recent-activity-feed'));
  initWorkflowQuestionWizards();
  initCaseTriageForm();
  initTours();
  initCheckResultForm();
});

// Export various things via `window` so that our javascript in
// `app/assets/javascript` can reference it.

window.emojiMart = emojiMart;
window.initVdc2d = initVdc2d;
